<div class="dialog" role="document" aria-labelledby="media-edit-title">
  <div class="dialog-header">
    <span class="dialog-title" id="media-edit-title">Edit media</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form" novalidate (ngSubmit)="submit()">
    <img class="preview-img" [src]="data.media.imageUrl" [alt]="data.media.name" />

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="media-edit-name">Name <span aria-hidden="true">*</span></label>
        <input id="media-edit-name" type="text" class="text-box-active" maxlength="255" formControlName="name" />
      </div>
      <div class="field">
        <label class="field-label" id="media-edit-category-label">Category <span aria-hidden="true">*</span></label>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select aria-labelledby="media-edit-category-label" panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="category">
            @for(c of categories; track c){ <mat-option [value]="c">{{ c | titlecase }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <label class="field-label" for="media-edit-remarks">Remarks</label>
      <input id="media-edit-remarks" type="text" class="text-box-active" maxlength="1000" formControlName="remarks" />
    </div>

    <div class="dialog-actions">
      <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
      <button type="submit" class="ac-primary-btn" [disabled]="isLoading">Save</button>
    </div>
  </form>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
